export class GetCountriesAction {
  static readonly type = '[Country] Get';
  constructor() {}
}
